import { createActions } from 'redux-actions';

export const { talentNetworkIntroCtaClicked } = createActions('TalentNetworkIntroCtaClicked');
